import { render, staticRenderFns } from "./DashboardCurrency.vue?vue&type=template&id=71afca56&scoped=true"
import script from "./DashboardCurrency.vue?vue&type=script&lang=js"
export * from "./DashboardCurrency.vue?vue&type=script&lang=js"
import style0 from "./DashboardCurrency.vue?vue&type=style&index=0&id=71afca56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71afca56",
  null
  
)

export default component.exports